/** Aplica máscara 00000-000 */
export function mascaraCep(valor: string): string {
  const nums = valor.replace(/\D/g, "").slice(0, 8)
  if (nums.length <= 5) return nums
  return `${nums.slice(0, 5)}-${nums.slice(5)}`
}

/**
 * CEP tem oito dígitos, e é só isso que dá para conferir aqui.
 *
 * Não existe dígito verificador de CEP: se ele existe de verdade, quem responde é
 * a consulta de endereço. Por isso a validação local só pega o comprimento, e o
 * "não encontramos este CEP" vem de quem buscou.
 */
export function cepCompleto(valor: string): boolean {
  return valor.replace(/\D/g, "").length === 8
}

export type EnderecoDoCep = {
  logradouro: string
  bairro: string
  cidade: string
  estado: string
}

/**
 * Busca o endereço do CEP nos Correios (via ViaCEP).
 *
 * Devolve `null` quando o CEP não existe, em vez de lançar: para quem preenche,
 * "não encontramos este CEP" é uma mensagem no campo, e não uma falha de tela.
 */
export async function buscarEnderecoDoCep(cep: string): Promise<EnderecoDoCep | null> {
  const nums = cep.replace(/\D/g, "")
  if (nums.length !== 8) return null
  try {
    const resposta = await fetch(`https://viacep.com.br/ws/${nums}/json/`)
    if (!resposta.ok) return null
    const dados = await resposta.json()
    if (!dados || dados.erro) return null
    return {
      logradouro: dados.logradouro || "",
      bairro: dados.bairro || "",
      cidade: dados.localidade || "",
      estado: dados.uf || "",
    }
  } catch {
    return null
  }
}
